<template>
  <div id="Island">
    <bg-video ref="bv" :class="{ blur }" filename="Island" autoplay loop/>
    <logo/>
    <DDD v-if="visiable" ref="a" @close="next(step + 1)"/>
    <guide-button class="btn-lt" @click.native="next(step - 1)">返回</guide-button>
    <guide-button class="btn-rt" @click.native="handleNarrateEnded">继续</guide-button>
  </div>
</template>

<script>
import DDD from '@/views/SubPage/3D'
import logo from '../Logo'
export default {
  name: 'Island',
  components: {
    DDD,
    logo,
  },
  data () {
    return {
      blur: false,
      visiable: false,
      step: this.$route.meta.back ? 2 : (this.$route.query.step || 0),
      fnList: [
        () => this.playNarrate('05', { btnText: '人工岛三维透视' })
          .then(_ => {
            this.visiable = true
            this.$nextTick(() => {
              this.$refs.a.play()
            })
          }),
        () => this.playNarrate('06', { btnText: '世界首创钢圆筒快速筑岛法' }).then(_ => this.$vplayer.play({ url: 'kszd' })).then(() => this.next(this.step + 1)),
        () => this.playNarrate('07', { btnText: '港珠澳大桥海底沉管隧道建设' }).then(_ => this.$router.push('/Part01/Tunnel')),
      ],
    }
  },
  mounted () {
    this.next(this.step)
  },
  methods: {
    next (step) {
      this.$vplayer.clear()
      if (step < 0) {
        this.$router.push('/Part01/Nav')
      }
      this.blur = false
      this.$refs.bv.play()
      this.step = step
      this.visiable = false
      this.fnList[step]()
    },
    playNarrate (filename, opts) {
      this.blur = false
      this.$refs.bv.play()
      return this.$narrate.play(filename, { ...opts, onended: this.handleNarrateEnded })
    },
    handleNarrateEnded () {
      this.$narrate.skip()
      this.$refs.bv.pause()
      this.blur = true
    },
  },
}
</script>
